// extracted by mini-css-extract-plugin
export default {"container":"org-side-panel_container__tijXK","topSection":"org-side-panel_topSection__9K+2K","title":"org-side-panel_title__eSCs9"};